
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.547 21.772a3.377 3.377 0 00-3.362-3.362c-.697 0-1.393.205-1.927.615-.491-1.23-1.721-2.131-3.116-2.131-.697 0-1.394.205-1.927.615-.492-1.23-1.722-2.132-3.117-2.132-.615 0-1.188.163-1.681.451l.001-7.751c0-.902-.368-1.763-.983-2.378-.657-.615-1.477-.984-2.378-.984a3.377 3.377 0 00-3.362 3.362l-.002 17.343-2.336-2.336a3.412 3.412 0 00-4.305-.41c-.779.533-1.312 1.393-1.477 2.336-.123.944.123 1.927.738 2.665l6.928 8.364c2.092 2.501 5.125 3.976 8.405 3.976h4.305a9.578 9.578 0 006.847-2.828 9.679 9.679 0 002.828-6.847l-.08-8.568zm-4.019 14.185a7.94 7.94 0 01-5.658 2.337h-4.303a9.267 9.267 0 01-7.134-3.362l-6.89-8.363a1.607 1.607 0 01-.368-1.354c.082-.491.328-.901.738-1.188.287-.205.615-.287.984-.287.451 0 .901.164 1.23.492l2.788 2.747c.41.41 1.025.533 1.558.287.534-.205.862-.739.862-1.312l-.002-17.877c0-.943.739-1.682 1.682-1.682.452 0 .862.164 1.188.492.329.328.492.738.492 1.188v12.342c0 .452.368.82.82.82.452 0 .82-.368.82-.82v-1.682c0-.943.738-1.681 1.682-1.681.943 0 1.681.738 1.681 1.681v3.199c0 .451.369.82.82.82.452 0 .82-.369.82-.82v-1.682c0-.943.739-1.681 1.682-1.681s1.682.738 1.682 1.681v3.199c0 .451.368.82.82.82.451 0 .82-.369.82-.82v-1.682c0-.943.738-1.682 1.681-1.682.944 0 1.682.739 1.682 1.682v8.568c.162 2.095-.658 4.103-2.177 5.62z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.783 8.938c.452 0 .82-.368.82-.82 0-2.951 2.419-5.371 5.372-5.371 2.952 0 5.372 2.418 5.372 5.371 0 .452.368.82.82.82.452 0 .82-.368.82-.82a7.051 7.051 0 00-7.051-7.051 7.051 7.051 0 00-7.052 7.051c.038.41.448.82.9.82z","fill":"currentColor"}})])
          )
        }
      }
    